import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../../components/ui/Button";
import { FiHome } from "react-icons/fi";

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-500 to-primary-700 flex items-center justify-center p-4">
      <div className="text-center text-white max-w-lg">
        <h1 className="text-8xl font-extrabold mb-4">404</h1>
        <h2 className="text-2xl font-bold mb-2">SORRY!</h2>
        <p className="text-lg font-light mb-8 opacity-90">
          The page you're looking for was not found.
        </p>
        <Link to="/">
          <Button variant="secondary" size="lg" leftIcon={<FiHome />}>
            Back to Login
          </Button>
        </Link>
        <p className="mt-8 text-sm opacity-60">
          Copyright &copy; {new Date().getFullYear()} All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default NotFound;
